import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting, reset} from 'redux-form';

import {PartialTenantInfo} from 'components/TenantInfo';
import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';
import {
  AgreementUserEditForm,
  Buttons,
  AgreementUserAvatar
} from './components';

import {fetchBooking} from 'ducks/bookings';
import {fetchCountries} from 'ducks/countries';
import {selectModal, storeDataInModal, openModal, MODALS} from 'ducks/modals';
import {
  MODALS as AGREEMENT_USER_MODALS,
  fetchAgreementUser
} from 'ducks/agreementUsers';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import './styles.css';

class AgreementUserInfoModal extends React.Component<any> {
  turnOnEditMode = () =>
    this.props.requiresPermission(
      {
        locationRef: this.props.data.locationRef,
        permission: PERMISSIONS.EDIT_MEMBER_INFORMATION
      },
      () =>
        this.props.storeDataInModal({
          modalName: AGREEMENT_USER_MODALS.AGREEMENT_USER_INFO,
          data: {
            isInEditMode: true
          }
        })
    );

  turnOffEditMode = () => {
    this.props.storeDataInModal({
      modalName: AGREEMENT_USER_MODALS.AGREEMENT_USER_INFO,
      data: {
        isInEditMode: false
      }
    });
    this.props.reset('agreementUserEdit');
  };

  submitForm = () => this.props.submit('agreementUserEdit');

  getStoreModalDataExtraActions = () => {
    return this.props.storeDataExtraActions(data => ({
      agreementUser: data
    }));
  };

  getExtraActions = () => {
    const {data: {agreementUserId, bookingId, locationRef}} = this.props;
    const storeModalDataExtraActions = this.getStoreModalDataExtraActions();

    return [
      () => fetchAgreementUser({agreementUserId}, storeModalDataExtraActions),
      () => fetchBooking({locationRef, bookingId}),
      () =>
        storeDataInModal({
          modalName: AGREEMENT_USER_MODALS.AGREEMENT_USER_INFO,
          data: {isInEditMode: false}
        })
    ];
  };

  componentDidMount() {
    const {data: {agreementUserId}} = this.props;
    const extraActions = this.getStoreModalDataExtraActions();

    this.props.fetchCountries();
    this.props.fetchAgreementUser({agreementUserId}, extraActions);
  }

  closeModal = () => {
    const {data: {bookingId, locationRef}} = this.props;

    this.props.closeModal();
    this.props.fetchBooking({locationRef, bookingId});
  };

  openTakePhotoModal = () => {
    const {data: {locationRef, agreementUserId}} = this.props;

    const extraActions = [
      () =>
        fetchAgreementUser({agreementUserId}, [
          agreementUser =>
            storeDataInModal({
              modalName: AGREEMENT_USER_MODALS.AGREEMENT_USER_INFO,
              data: {
                agreementUser
              }
            })
        ])
    ];

    this.props.requiresPermission(
      {
        permission: PERMISSIONS.EDIT_MEMBER_INFORMATION,
        locationRef
      },
      () => {
        this.props.openModal(MODALS.AGREEMENT_USER_TAKE_PHOTO, {
          locationRef,
          agreementUserId,
          extraActions
        });
      }
    );
  };

  render() {
    const {
      isInEditMode,
      form: {submitting},
      data: {agreementUser, locationRef, bookingId}
    } = this.props;
    return (
      <Modal
        className="AgreementUserInfoModal"
        show={!_.isNil(agreementUser)}
        type={Modal.EXTRA_SMALL}
        onClose={this.closeModal}>
        <Modal.Header heading="Member Information" />
        <Modal.Body>
          {agreementUser && (
            <div>
              <div className="headerInfo">
                <PartialTenantInfo tenant={agreementUser} />
                <Button blue onClick={this.openTakePhotoModal}>
                  Take a photo
                </Button>
              </div>
              <div className="baseInfo">
                <AgreementUserAvatar
                  agreementUser={agreementUser}
                  locationRef={locationRef}
                  bookingId={bookingId}
                />
                <AgreementUserEditForm
                  agreementUser={agreementUser}
                  isInEditMode={isInEditMode}
                  locationRef={locationRef}
                  getExtraActions={this.getExtraActions}
                />
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            isInEditMode={isInEditMode}
            turnOnEditMode={this.turnOnEditMode}
            turnOffEditMode={this.turnOffEditMode}
            submitting={submitting}
            submitForm={this.submitForm}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  submit,
  reset,
  fetchAgreementUser,
  storeDataInModal,
  fetchCountries,
  fetchBooking,
  requiresPermission,
  openModal
};

const mapStateToProps = state => {
  const {data: {isInEditMode}} = selectModal(
    state,
    AGREEMENT_USER_MODALS.AGREEMENT_USER_INFO
  );

  return {
    form: {
      submitting: isSubmitting('agreementUserEdit')(state)
    },
    isInEditMode: isInEditMode || false // TODO: Solve this when intorducing modal's initial state
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(AGREEMENT_USER_MODALS.AGREEMENT_USER_INFO)(AgreementUserInfoModal)
);
